export const extractSubdomain = () => {
	const isBrowser = typeof window !== 'undefined';

	if (!isBrowser) {
		return '';
	}

	const fullHostName = window.location.host;
	const hostNameParts = fullHostName.split('.');

	const subdomain = process.env.NEXT_PUBLIC_LOCAL_DOMAIN || hostNameParts[0];

	const allDomains = ['drive', 'school'];

	return allDomains.includes(subdomain) ? 'drive' : 'my';
};
